export const CAPABILITY = {
    AMZL_CORE: "AMZL_CORE",
    AR_NEXT_GEN: "AR_NEXT_GEN"
}



// WEBPACK FOOTER //
// ./src/components/util/Constants.js